// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, "\n.small[data-v-4adc169d] {\r\n  width: 100%;\r\n  text-align: center;\r\n  font-size: 10px;\r\n  line-height: 10px;\r\n  padding-top: 5px;\r\n  margin: 0;\n}\n.passworderror[data-v-4adc169d] {\r\n  background: transparent;\r\n  color: red;\r\n  font-weight: bold;\n}\n.clean[data-v-4adc169d] {\r\n  background: none !important;\n}\n.account[data-v-4adc169d] {\r\n  color: blue;\n}\n.account .small[data-v-4adc169d] {\r\n  font-size: 10px;\n}\r\n\r\n", ""]);
// Exports
module.exports = exports;
